<template>
    <div v-if="Role === '1'">
        <div class="p-layout-breadcrumb">
            <el-row type="flex" align="middle">
                <el-col :span="5">
                    <h3 v-if="isAlipay">支付宝小程序帮助中心</h3>
                    <h3 v-if="!isAlipay">帮助中心</h3>
                </el-col>
            </el-row>

            <el-card class="box-card">
                <div slot="header" class="clearfix">
                    <span style="line-height: 36px;">{{titles[0]}}</span>
                    <el-button style="float: right;" type="primary" @click="addCommon">添加</el-button>
                </div>
                <div v-for="(o,i) in comonQ" :key="i" class="text item">
                    <p>
                        标题：{{ o.Q }}
                    </p>
                    <p>
                        内容：{{ o.A }}
                    </p>
                    <el-button type="danger" @click="commonDelete(i)">删除</el-button>
                    <el-button type="info" @click="commonEdit(i)">编辑</el-button>
                </div>
            </el-card>

            <el-card class="box-card">
                <div slot="header" class="clearfix">
                    <span style="line-height: 36px;">{{titles[1]}}</span>
                    <el-button style="float: right;" type="primary" @click="addPay">添加</el-button>
                </div>
                <div v-for="(o,i) in payQ" :key="i" class="text item">
                    <p>
                        标题：{{ o.Q }}
                    </p>
                    <p>
                        内容：{{ o.A }}
                    </p>
                    <el-button type="danger" @click="payDelete(i)">删除</el-button>
                    <el-button type="info" @click="payEdit(i)">编辑</el-button>
                </div>
            </el-card>

            <el-card class="box-card">
                <div slot="header" class="clearfix">
                    <span style="line-height: 36px;">{{titles[2]}}</span>
                    <el-button style="float: right;" type="primary" @click="addDinner">添加</el-button>
                </div>
                <div v-for="(o,i) in dinnerQ" :key="i" class="text item">
                    <p>
                        标题：{{ o.Q }}
                    </p>
                    <p>
                        内容：{{ o.A }}
                    </p>
                    <el-button type="danger" @click="orderDelete(i)">删除</el-button>
                    <el-button type="info" @click="orderEdit(i)">编辑</el-button>
                </div>
            </el-card>



            <el-dialog :title="'新增' + titles[0]" :visible.sync="dialogCommon" size="large">
                <el-form :model="newForm" ref="newForm" :rules="addStorageRules">
                    <el-form-item label="标题" label-width="150px" prop="Q">
                        <el-input v-model="newForm.Q" auto-complete="off"></el-input>
                    </el-form-item>
                    <el-form-item label="内容" label-width="150px" prop="A">
                        <el-input type="textarea" v-model="newForm.A" auto-complete="off"></el-input>
                    </el-form-item>

                </el-form>
                <div slot="footer" class="dialog-footer">
                    <el-button @click="dialogCommon = false">取 消</el-button>
                    <el-button type="primary" @click="addCommonOne">确 定</el-button>
                </div>
            </el-dialog>

            <el-dialog :title="'编辑' + titles[1]" :visible.sync="dialogCommonEdit" size="large">
                <el-form :model="newForm" ref="newForm" :rules="addStorageRules">
                    <el-form-item label="标题" label-width="150px" prop="Q">
                        <el-input v-model="newForm.Q" auto-complete="off"></el-input>
                    </el-form-item>
                    <el-form-item label="内容" label-width="150px" prop="A">
                        <el-input type="textarea" v-model="newForm.A" auto-complete="off"></el-input>
                    </el-form-item>

                </el-form>
                <div slot="footer" class="dialog-footer">
                    <el-button @click="dialogCommonEdit = false">取 消</el-button>
                    <el-button type="primary" @click="editCommonOne">保 存</el-button>
                </div>
            </el-dialog>

            <el-dialog :title="'编辑' + titles[2]" :visible.sync="dialogPayEdit" size="large">
                <el-form :model="newForm" ref="newForm" :rules="addStorageRules">
                    <el-form-item label="标题" label-width="150px" prop="Q">
                        <el-input v-model="newForm.Q" auto-complete="off"></el-input>
                    </el-form-item>
                    <el-form-item label="内容" label-width="150px" prop="A">
                        <el-input type="textarea" v-model="newForm.A" auto-complete="off"></el-input>
                    </el-form-item>

                </el-form>
                <div slot="footer" class="dialog-footer">
                    <el-button @click="dialogPayEdit = false">取 消</el-button>
                    <el-button type="primary" @click="editPayOne">保 存</el-button>
                </div>
            </el-dialog>

            <el-dialog title="编辑订单问题" :visible.sync="dialogDinnerEdit" size="large">
                <el-form :model="newForm" ref="newForm" :rules="addStorageRules">
                    <el-form-item label="标题" label-width="150px" prop="Q">
                        <el-input v-model="newForm.Q" auto-complete="off"></el-input>
                    </el-form-item>
                    <el-form-item label="内容" label-width="150px" prop="A">
                        <el-input type="textarea" v-model="newForm.A" auto-complete="off"></el-input>
                    </el-form-item>

                </el-form>
                <div slot="footer" class="dialog-footer">
                    <el-button @click="dialogDinnerEdit = false">取 消</el-button>
                    <el-button type="primary" @click="editDinnerOne">保 存</el-button>
                </div>
            </el-dialog>

            <el-dialog title="新增订单问题" :visible.sync="dialogDinner" size="large">
                <el-form :model="newForm" ref="newForm" :rules="addStorageRules">
                    <el-form-item label="标题" label-width="150px" prop="Q">
                        <el-input v-model="newForm.Q" auto-complete="off"></el-input>
                    </el-form-item>
                    <el-form-item label="内容" label-width="150px" prop="A">
                        <el-input type="textarea" v-model="newForm.A" auto-complete="off"></el-input>
                    </el-form-item>

                </el-form>
                <div slot="footer" class="dialog-footer">
                    <el-button @click="dialogCommon = false">取 消</el-button>
                    <el-button type="primary" @click="addDinnerOne">确 定</el-button>
                </div>
            </el-dialog>

            <el-dialog title="新增支付问题" :visible.sync="dialogPay" size="large">
                <el-form :model="newForm" ref="newForm" :rules="addStorageRules">
                    <el-form-item label="标题" label-width="150px" prop="Q">
                        <el-input v-model="newForm.Q" auto-complete="off"></el-input>
                    </el-form-item>
                    <el-form-item label="内容" label-width="150px" prop="A">
                        <el-input type="textarea" v-model="newForm.A" auto-complete="off"></el-input>
                    </el-form-item>

                </el-form>
                <div slot="footer" class="dialog-footer">
                    <el-button @click="dialogCommon = false">取 消</el-button>
                    <el-button type="primary" @click="addPayOne">确 定</el-button>
                </div>
            </el-dialog>

            <el-button type="primary" @click="uploadHelp">提交</el-button>
        </div>

    </div>
    <h3 v-else>
        暂无权限
    </h3>
</template>

<script>
    import {
        getHelp,
        patchHelp
    } from '../../api/version'

    export default {
        data() {
            return {
                 Role: sessionStorage.power,
                comonQ: [],
                dinnerQ: [],
                payQ: [],
                cur: '',
                dialogCommon: false,
                dialogPay: false,
                dialogDinner: false,
                dialogCommonEdit: false,
                dialogDinnerEdit: false,
                dialogPayEdit: false,
                titles: [],
                addStorageRules: {
                    Q: [{
                        required: true,
                        message: '请填写标题',
                        trigger: 'blur'
                    }],
                    A: [{
                        required: true,
                        message: '请填写内容',
                        trigger: 'blur'
                    }],

                },
                newForm: {
                    Q: '',
                    A: ''
                },


            }
        },
        computed: {
            isAlipay() {
                return this.$route.path === '/alipayHelp';
            },
            editId() {
                let id = 6;

                if (this.isAlipay) {
                    id = 51;
                }

                return id;
            }
        },
        created() {
            this.loadData();
        },
        watch: {
            '$route' () {
                this.loadData();
            }
        },
        methods: {

            loadData() {
                getHelp(this.editId).then(res => {
                    this.comonQ = res.data.value[0].content
                    this.payQ = res.data.value[1].content
                    this.dinnerQ = res.data.value[2].content

                    res.data.value.forEach((item) => {
                        this.titles.push(item.title);
                    });
                })
            },

            addCommon() {
                this.dialogCommon = true
            },
            addCommonOne() {
                //comonQ
                this.$refs['newForm'].validate((valid) => {
                    if (valid) {
                        this.comonQ.push(JSON.parse(JSON.stringify(this.newForm)))

                        this.newForm = {
                            Q: '',
                            A: ''
                        }
                        this.dialogCommon = false
                    }
                })
            },

            addDinnerOne() {
                //comonQ
                this.$refs['newForm'].validate((valid) => {
                    if (valid) {
                        this.dinnerQ.push(JSON.parse(JSON.stringify(this.newForm)))

                        this.newForm = {
                            Q: '',
                            A: ''
                        }
                        this.dialogDinner = false
                    }
                })
            },

            addPayOne() {
                //comonQ
                this.$refs['newForm'].validate((valid) => {
                    if (valid) {
                        this.payQ.push(JSON.parse(JSON.stringify(this.newForm)))

                        this.newForm = {
                            Q: '',
                            A: ''
                        }
                        this.dialogPay = false
                    }
                })
            },
            addDinner() {
                this.dialogDinner = true
            },
            addPay() {
                this.dialogPay = true
            },
            uploadHelp() {
                let data = {
                    value: [{
                            'title': this.titles[0],
                            'content': []
                        },
                        {
                            'title': this.titles[1],
                            'content': []
                        },
                        {
                            'title': this.titles[2],
                            'content': []
                        }
                    ]
                };

                data.value[0].content = this.comonQ
                data.value[1].content = this.payQ
                data.value[2].content = this.dinnerQ
                patchHelp(this.editId, sessionStorage.userId, data).then(res => {
                    if (res.data) {
                        this.$message({
                            message: '更新成功',
                            type: 'success'
                        });
                    }
                })
            },
            // 常见问题删除
            commonDelete(index) {
                this.comonQ.splice(index, 1)
                // console.log(index)
                // this.$confirm('此操作将删除该问题, 是否继续?', '提示', {
                //     confirmButtonText: '确定',
                //     cancelButtonText: '取消',
                //     type: 'warning'
                // }).then(() => {
                //      this.comonQ.splice(index,1)
                //     this.uploadHelp()

                // }).catch(() => {
                //     this.$message({
                //         type: 'info',
                //         message: '已取消删除'
                //     });
                // });
            },
            // 常见问题编辑
            commonEdit(index) {
                console.log(index)
                this.cur = index
                this.dialogCommonEdit = true
                this.newForm = this.comonQ[index]
            },
            //常见问题编辑保存
            editCommonOne() {
                this.$refs['newForm'].validate((valid) => {
                    if (valid) {
                        this.comonQ.splice(this.cur, 1, this.newForm)

                        this.newForm = {
                            Q: '',
                            A: ''
                        }
                        this.dialogCommonEdit = false
                        this.$message({
                            message: '保存成功',
                            type: 'success'
                        });
                    }
                })
            },
            // 支付问题删除
            payDelete(index) {
                this.payQ.splice(index, 1)
            },
            // 支付问题编辑
            payEdit(index) {
                this.cur = index
                this.dialogPayEdit = true
                this.newForm = this.payQ[index]
            },
            // 订单问题删除
            orderDelete(index) {
                this.dinnerQ.splice(index, 1)
            },
            orderEdit(index) {
                this.cur = index
                this.dialogDinnerEdit = true
                this.newForm = this.dinnerQ[index]
            },
            //支付问题编辑保存
            editPayOne() {
                this.$refs['newForm'].validate((valid) => {
                    if (valid) {
                        this.payQ.splice(this.cur, 1, this.newForm)

                        this.newForm = {
                            Q: '',
                            A: ''
                        }
                        this.dialogPayEdit = false
                        this.$message({
                            message: '保存成功',
                            type: 'success'
                        });
                    }
                })
            },
            //订单问题编辑保存
            editDinnerOne() {
                this.$refs['newForm'].validate((valid) => {
                    if (valid) {
                        this.dinnerQ.splice(this.cur, 1, this.newForm)

                        this.newForm = {
                            Q: '',
                            A: ''
                        }
                        this.dialogDinnerEdit = false
                        this.$message({
                            message: '保存成功',
                            type: 'success'
                        });
                    }
                })
            }

        }
    }
</script>

<style scoped>
    .text.item {
        border-bottom: 1px solid #ccc;
        margin-bottom: 20px;
        padding-bottom: 20px;
    }

    .el-card {
        margin-bottom: 30px;
    }

    .user-pic {
        width: 50px;
        height: 50px;
        margin-top: 10px;
    }

    .avatar-uploader .el-upload {
        background-color: #fbfdff;
        border: 1px dashed #c0ccda;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
    }

    .avatar-uploader .el-upload:hover {
        border-color: #20a0ff;
    }

    .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 178px;
        height: 178px;
        line-height: 178px;
        text-align: center;
    }

    .avatar {
        width: 178px;
        height: 178px;
        display: block;
    }

    .page-footer {
        margin-top: 60px;
        text-align: center;
    }
</style>



// WEBPACK FOOTER //
// Help.vue?44c3ab12